import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';
import * as CritereOperators from '../CritereOperateurs.js';
import { debouncedSuggestThesaurus } from '../repositories/ThesaurusRepository.js';
import { CustomAsyncSelect } from './CustomSelect.js';

const OPTIONS = [
  { value: 'Auteur', label: 'Auteur' },
  { value: 'Afig', label: 'Auteur de la source figurée' },
  { value: 'AtelierEcole', label: 'Atelier ou école' },
  { value: 'Personnalite', label: 'Personnalité' },
];

const ThesaurusField = ({ fieldDefinition, name, defaultValue, onChange }) => {
  const [currentInput, setCurrentInput] = useState(defaultValue?.label || '');
  const [menuOpen, setMenuOpen] = useState(false);
  const handleChange = (option) => {
    if (!option) {
      setCurrentInput(() => '');
      onChange(null);
      return;
    }

    const { value, label, ancestorLabels, __isNew__ } = option;
    if (__isNew__) {
      onChange({
        valeur: value,
        label,
        ancestorLabels,
        operateur: CritereOperators.LABEL_CONTAINS,
      });
    } else {
      onChange({
        valeur: value,
        label,
        ancestorLabels,
        operateur: CritereOperators.EQUAL,
      });
    }
    setCurrentInput(() => label);
  };

  const suggestThesaurus = useMemo(
    () => debouncedSuggestThesaurus(name),
    [name],
  );

  return (
    <CustomAsyncSelect
      className="critere-input"
      value={defaultValue || null}
      inputValue={menuOpen ? currentInput : ''}
      name={name}
      onChange={handleChange}
      options={OPTIONS}
      defaultOptions
      cacheOptions
      loadOptions={(input) =>
        suggestThesaurus(
          input,
          fieldDefinition?.typeThesaurus,
          fieldDefinition?.onlyDepartement,
          30,
        )
      }
      getOptionLabel={(option) => (
        <div className="thesaurus-field-option">
          <p className="thesaurus-field-option-label">{option.label}</p>
          {option.ancestorLabels?.length ? (
            <p className="thesaurus-field-option-ancestors">
              {option.ancestorLabels.join(' / ')}
            </p>
          ) : null}
        </div>
      )}
      formatCreateLabel={(input) => (
        <>
          Recherche via le libellé &quot;
          <span className="critere-thesaurus-find-by-label">{input}</span>
          &quot;
        </>
      )}
      createOptionPosition="first"
      onInputChange={(value, event) => {
        if (event.action === 'input-change') {
          handleChange({
            value,
            label: value,
            ancestorLabels: [],
            __isNew__: true,
          });
        }
        // si event.action === "set-value", cela signifie que l'utiisateur a sélectionné une option
        // on ne fait rien dans ce cas
      }}
      onMenuOpen={() => {
        setMenuOpen(true);
      }}
      onMenuClose={() => {
        setMenuOpen(false);
      }}
    />
  );
};
ThesaurusField.propTypes = {
  fieldDefinition: PropTypes.shape({
    typeThesaurus: PropTypes.array,
    onlyDepartement: PropTypes.boolean,
  }).isRequired,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.shape({
    valeur: PropTypes.string,
    label: PropTypes.string,
    operateur: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

export default ThesaurusField;
